import React from "react";
import { buttonActionClassGray } from "helpers/StyleClass";
import AppliedUprModal from "./AppliedUprModal";
import { useAnatomyFilter, useAnatomyData } from "./context/AnatomyContexts";

class AppliedUprButtonInner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
    };
  }

  render() {
    const { isOpenModal } = this.state;
    const { unitId, unitName, networkId, startDate, includeToday } = this.props;

    return (
      <>
        <button
          type="button"
          className={buttonActionClassGray}
          onClick={() => this.setState({ isOpenModal: true })}
        >
          Get Applied UPR
        </button>
        {isOpenModal && (
          <AppliedUprModal
            unitId={unitId}
            unitName={unitName}
            networkId={networkId}
            startDate={startDate}
            includeToday={includeToday}
            handleClose={() => this.setState({ isOpenModal: false })}
          ></AppliedUprModal>
        )}
      </>
    );
  }
}

const AppliedUprButton = React.memo((props) => {
  const filterContext = useAnatomyFilter();
  const dataContext = useAnatomyData();

  if (!filterContext || !dataContext) {
    return <AppliedUprButtonInner {...props} />;
  }

  return (
    <AppliedUprButtonInner
      {...props}
      unitId={dataContext.unitInfo.gamUnitId}
      unitName={dataContext.unitInfo.name}
      networkId={dataContext.unitInfo.networkId}
      startDate={filterContext.startDate}
      includeToday={filterContext.includeToday}
    />
  );
});

export default AppliedUprButton;
